import React from 'react'
import type { RouteProps } from 'react-router-dom'

import ProtectedRoute, { SessionState } from '../routes/ProtectedRoute'
import OnboardingLayout from '../layouts/OnboardingLayout'

function AuthRoute(props: RouteProps) {
  return (
    <ProtectedRoute
      layout={OnboardingLayout}
      requiredSessionState={SessionState.LOGGED_OUT}
      {...props}
    />
  )
}

export default AuthRoute
